export default __webpack_public_path__ + "assets/images/0c7950c8eb0bdefc28e7ca57b4475490.png";